import React from 'react';
import { useParams } from 'react-router-dom';
import SearchConsole from './SearchConsole';

// /brands/:id/search-console — the internal brand detail page's Search
// Console tab: staff connecting a brand's domain on its behalf.
export default function BrandDetailSearchConsoleTab() {
  const { id } = useParams();
  const brandId = id ? parseInt(id, 10) : 0;
  if (!brandId) return null;
  return <SearchConsole brandId={brandId} />;
}
